// import {
//   Box,
//   Maximize,
//   Scan,
//   Layers,
//   CheckCircle,
//   ArrowRight,
//   Crosshair,
//   Grid3x3,
//   Cuboid,
//   Sparkles,
// } from "lucide-react";
// import { useEffect, useRef, useState } from "react";

// const TwoDThreeDService = () => {
//   const observerRefs = useRef([]);
//   const [visibleElements, setVisibleElements] = useState(new Set());

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setVisibleElements((prev) => new Set([...prev, entry.target]));
//           }
//         });
//       },
//       { threshold: 0.1, rootMargin: "50px" }
//     );

//     observerRefs.current.forEach((ref) => {
//       if (ref) observer.observe(ref);
//     });

//     return () => observer.disconnect();
//   }, []);

//   const addToRefs = (el) => {
//     if (el && !observerRefs.current.includes(el)) {
//       observerRefs.current.push(el);
//     }
//   };

//   const annotation2D = [
//     {
//       icon: Box,
//       title: "Bounding Boxes",
//       description:
//         "Rectangular object detection for classification and localization tasks.",
//     },
//     {
//       icon: Scan,
//       title: "Polygon Annotation",
//       description:
//         "Precise irregular boundary tracing for complex object shapes.",
//     },
//     {
//       icon: Maximize,
//       title: "Keypoint Detection",
//       description:
//         "Landmark identification for pose estimation and facial recognition.",
//     },
//     {
//       icon: Layers,
//       title: "Semantic Segmentation",
//       description:
//         "Pixel-level classification for detailed scene understanding.",
//     },
//   ];

//   const annotation3D = [
//     {
//       title: "LiDAR Point Clouds",
//       description: "Dense 3D spatial data annotation for autonomous systems.",
//     },
//     {
//       title: "3D Cuboid Labeling",
//       description: "Volumetric bounding boxes with orientation and depth.",
//     },
//     {
//       title: "Depth Map Annotation",
//       description: "Distance estimation and surface reconstruction labeling.",
//     },
//     {
//       title: "Sensor Fusion",
//       description:
//         "Multi-modal data integration from cameras, radar, and LiDAR.",
//     },
//     {
//       title: "Instance Segmentation",
//       description: "Individual object isolation in 3D space.",
//     },
//     {
//       title: "Temporal Tracking",
//       description: "Object trajectory labeling across sequential frames.",
//     },
//   ];

//   const applications = [
//     {
//       title: "Autonomous Vehicles",
//       description:
//         "Road scene understanding, obstacle detection, and navigation systems.",
//     },
//     {
//       title: "Robotics & Automation",
//       description:
//         "Object manipulation, environment mapping, and path planning.",
//     },
//     {
//       title: "Medical Imaging",
//       description:
//         "Diagnostic annotation, organ segmentation, and pathology detection.",
//     },
//     {
//       title: "Retail & E-commerce",
//       description:
//         "Product recognition, inventory management, and visual search.",
//     },
//     {
//       title: "Agriculture",
//       description: "Crop monitoring, disease detection, and yield prediction.",
//     },
//     {
//       title: "Security & Surveillance",
//       description:
//         "Threat detection, facial recognition, and behavioral analysis.",
//     },
//   ];

//   const qualityFeatures = [
//     "Multi-tier quality assurance process",
//     "Expert annotator training programs",
//     "Consensus-based validation",
//     "Custom annotation guidelines",
//     "Inter-annotator agreement metrics",
//     "Continuous feedback loops",
//   ];

//   const technicalCapabilities = [
//     {
//       title: "High-Volume Processing",
//       description: "Scalable infrastructure handling millions of annotations.",
//     },
//     {
//       title: "Custom Taxonomies",
//       description: "Flexible labeling schemas tailored to your domain.",
//     },
//     {
//       title: "Multi-Format Support",
//       description: "JPEG, PNG, TIFF, DICOM, PCD, and proprietary formats.",
//     },
//     {
//       title: "API Integration",
//       description: "Seamless workflow integration with your ML pipeline.",
//     },
//   ];

//   const processSteps = [
//     {
//       title: "Requirements Analysis",
//       description:
//         "Define annotation taxonomy, quality metrics, and delivery timelines.",
//     },
//     {
//       title: "Data Preparation",
//       description: "Secure ingestion, preprocessing, and sample validation.",
//     },
//     {
//       title: "Annotation Execution",
//       description:
//         "Expert labeling with tool-assisted precision and guidelines.",
//     },
//     {
//       title: "Quality Assurance",
//       description:
//         "Multi-stage review, consensus validation, and metrics tracking.",
//     },
//     {
//       title: "Delivery & Iteration",
//       description:
//         "Export in standard formats with ongoing support and refinement.",
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-white font-inter">
//       <style>{`
//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes scaleIn {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .animate-on-scroll {
//           opacity: 0;
//         }

//         .animate-on-scroll.visible {
//           animation: fadeInUp 0.6s ease-out forwards;
//         }

//         .animate-scale {
//           opacity: 0;
//         }

//         .animate-scale.visible {
//           animation: scaleIn 0.5s ease-out forwards;
//         }

//         .hero-title {
//           animation: fadeInUp 0.8s ease-out forwards;
//         }

//         .hero-subtitle {
//           animation: fadeInUp 0.8s 0.2s ease-out backwards;
//         }

//         .hero-cta {
//           animation: fadeInUp 0.8s 0.4s ease-out backwards;
//         }

//         .stagger-1 { animation-delay: 0.1s; }
//         .stagger-2 { animation-delay: 0.2s; }
//         .stagger-3 { animation-delay: 0.3s; }
//         .stagger-4 { animation-delay: 0.4s; }
//         .stagger-5 { animation-delay: 0.5s; }
//         .stagger-6 { animation-delay: 0.6s; }
//       `}</style>

//       {/* HERO SECTION */}
//       <section className="relative h-[500px] overflow-hidden bg-slate-900">
//         {/* Background Image */}
//         <div
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage:
//               "url('https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=1920&q=80')",
//           }}
//         />

//         {/* Dark ecommerce-style overlay */}
//         <div className="absolute inset-0 bg-black/75" />

//         <div className="relative max-w-7xl mx-auto px-6 h-full flex items-center">
//           <div className="text-white max-w-3xl">
//             <h1 className="text-4xl sm:text-5xl font-light mb-4 tracking-tight">
//               2D & 3D Dataset Services
//             </h1>

//             <p className="text-lg mb-6 text-slate-300 font-light max-w-2xl">
//               Precision 2D and 3D labeling for computer vision, autonomous
//               systems, and spatial AI applications.
//             </p>

//             <button className="inline-flex items-center gap-2 bg-white text-slate-900 px-7 py-3 rounded-md font-medium hover:bg-slate-100 transition-colors">
//               Get Started
//               <ArrowRight className="w-4 h-4" />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* 2D ANNOTATION SERVICES */}
//       <section className="py-24 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div
//             ref={addToRefs}
//             className={`text-center mb-16 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[0]) ? "visible" : ""
//             }`}
//           >
//             <h2 className="text-4xl font-light mb-6 text-slate-900">
//               2D Annotation Services
//             </h2>
//             <p className="text-lg text-slate-600 max-w-3xl mx-auto font-light">
//               Industry-leading 2D image annotation for object detection,
//               classification, and segmentation across diverse datasets.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {annotation2D.map((service, index) => (
//               <div
//                 key={service.title}
//                 ref={addToRefs}
//                 className={`p-8 bg-slate-900 text-white hover:bg-slate-800 transition-colors animate-scale stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[index + 1])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <service.icon className="w-8 h-8 mb-4" />
//                 <h3 className="text-xl font-medium mb-3">{service.title}</h3>
//                 <p className="text-slate-300 font-light text-sm leading-relaxed">
//                   {service.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 3D ANNOTATION CAPABILITIES */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-7xl mx-auto">
//           <div
//             ref={addToRefs}
//             className={`flex items-center justify-center mb-4 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[5]) ? "visible" : ""
//             }`}
//           >
//             <Cuboid className="w-10 h-10 text-slate-700 mr-4" />
//             <h2 className="text-4xl font-light text-slate-900">
//               3D Annotation Capabilities
//             </h2>
//           </div>

//           <p
//             ref={addToRefs}
//             className={`text-center text-slate-600 mb-16 max-w-3xl mx-auto text-lg font-light animate-on-scroll ${
//               visibleElements.has(observerRefs.current[6]) ? "visible" : ""
//             }`}
//           >
//             Advanced 3D labeling for LiDAR point clouds, depth sensors, and
//             multi-modal sensor fusion for autonomous and robotic systems.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {annotation3D.map((capability, index) => (
//               <div
//                 key={capability.title}
//                 ref={addToRefs}
//                 className={`p-6 bg-white border border-slate-200 hover:border-slate-300 transition-colors animate-on-scroll stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[7 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <div className="flex items-start gap-3 mb-3">
//                   <div className="w-2 h-2 rounded-full bg-slate-700 mt-2"></div>
//                   <h3 className="text-lg font-medium text-slate-900">
//                     {capability.title}
//                   </h3>
//                 </div>
//                 <p className="text-slate-600 text-sm font-light pl-5">
//                   {capability.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* TECHNICAL CAPABILITIES */}
//       <section className="py-24 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <h2
//             ref={addToRefs}
//             className={`text-4xl font-light text-center mb-16 text-slate-900 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[13]) ? "visible" : ""
//             }`}
//           >
//             Technical Capabilities
//           </h2>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {technicalCapabilities.map((capability, index) => (
//               <div
//                 key={capability.title}
//                 ref={addToRefs}
//                 className={`p-8 bg-slate-900 text-white animate-scale stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[14 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <Grid3x3 className="w-6 h-6 mb-4" />
//                 <h3 className="text-xl font-medium mb-3">{capability.title}</h3>
//                 <p className="text-slate-300 font-light text-sm leading-relaxed">
//                   {capability.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* QUALITY ASSURANCE */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-6xl mx-auto">
//           <h2
//             ref={addToRefs}
//             className={`text-4xl font-light text-center mb-6 text-slate-900 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[18]) ? "visible" : ""
//             }`}
//           >
//             Quality Assurance
//           </h2>

//           <p
//             ref={addToRefs}
//             className={`text-center text-slate-600 mb-16 max-w-3xl mx-auto font-light animate-on-scroll ${
//               visibleElements.has(observerRefs.current[19]) ? "visible" : ""
//             }`}
//           >
//             Our multi-tier quality control ensures annotation accuracy exceeding
//             99% through rigorous validation and expert oversight.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             {qualityFeatures.map((feature, index) => (
//               <div
//                 key={index}
//                 ref={addToRefs}
//                 className={`p-6 bg-white border border-slate-200 hover:border-slate-300 transition-colors animate-on-scroll stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[20 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <CheckCircle className="w-6 h-6 mb-4 text-slate-700" />
//                 <p className="text-slate-800 font-light">{feature}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* INDUSTRY APPLICATIONS */}
//       <section className="py-24 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <h2
//             ref={addToRefs}
//             className={`text-4xl font-light text-center mb-16 text-slate-900 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[26]) ? "visible" : ""
//             }`}
//           >
//             Industry Applications
//           </h2>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {applications.map((app, index) => (
//               <div
//                 key={app.title}
//                 ref={addToRefs}
//                 className={`p-8 bg-slate-50 border border-slate-200 hover:border-slate-300 transition-colors animate-on-scroll stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[27 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <Layers className="w-6 h-6 text-slate-700 mb-4" />
//                 <h3 className="text-xl font-medium mb-3 text-slate-900">
//                   {app.title}
//                 </h3>
//                 <p className="text-slate-600 font-light text-sm leading-relaxed">
//                   {app.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ANNOTATION PROCESS */}
//       <section className="py-24 px-6 bg-slate-900 text-white">
//         <div className="max-w-6xl mx-auto">
//           <h2
//             ref={addToRefs}
//             className={`text-4xl font-light text-center mb-16 animate-on-scroll ${
//               visibleElements.has(observerRefs.current[33]) ? "visible" : ""
//             }`}
//           >
//             Annotation Process
//           </h2>

//           <div className="space-y-6">
//             {processSteps.map((step, index) => (
//               <div
//                 key={step.title}
//                 ref={addToRefs}
//                 className={`flex gap-6 p-8 bg-slate-800 border border-slate-700 hover:border-slate-600 transition-colors animate-on-scroll stagger-${
//                   index + 1
//                 } ${
//                   visibleElements.has(observerRefs.current[34 + index])
//                     ? "visible"
//                     : ""
//                 }`}
//               >
//                 <div className="flex-shrink-0">
//                   <div className="w-12 h-12 rounded-full bg-white text-slate-900 flex items-center justify-center font-medium">
//                     {index + 1}
//                   </div>
//                 </div>
//                 <div>
//                   <h3 className="text-xl font-medium mb-2">{step.title}</h3>
//                   <p className="text-slate-300 font-light leading-relaxed">
//                     {step.description}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="py-24 bg-white border-t border-slate-200">
//         <div
//           ref={addToRefs}
//           className={`max-w-4xl mx-auto text-center px-6 animate-on-scroll ${
//             visibleElements.has(observerRefs.current[39]) ? "visible" : ""
//           }`}
//         >
//           <h2 className="text-3xl sm:text-4xl font-light mb-8 text-slate-900">
//             Need Precision Annotation for Your Project?
//           </h2>

//           <button className="inline-flex items-center gap-2 bg-slate-900 text-white px-8 py-3 rounded-sm font-medium hover:bg-slate-800 transition-colors">
//             Request Annotation Services
//             <ArrowRight className="w-4 h-4" />
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default TwoDThreeDService;

import React from "react";
import { motion } from "framer-motion";
import {
  Box,
  Maximize,
  Scan,
  Layers,
  CheckCircle2,
  ArrowRight,
  Grid3x3,
  Cuboid,
  Database,
  ShieldCheck,
  Zap,
  Globe2,
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function TwoDThreeDService() {
  const annotation2D = [
    {
      icon: Box,
      title: "Bounding Boxes",
      desc: "High-precision 2D localization for object detection and classification.",
    },
    {
      icon: Scan,
      title: "Polygon Tracing",
      desc: "Pixel-perfect irregular boundary tracing for complex silhouettes.",
    },
    {
      icon: Maximize,
      title: "Keypoint Mapping",
      desc: "Landmark identification for pose estimation and biometric analysis.",
    },
    {
      icon: Layers,
      title: "Semantic Masking",
      desc: "Dense pixel-level classification for total scene understanding.",
    },
  ];

  const annotation3D = [
    {
      title: "LiDAR Point Clouds",
      desc: "Semantic labeling of complex spatial data for autonomous navigation.",
    },
    {
      title: "3D Cuboid Labeling",
      desc: "Volumetric boxes with precise orientation, depth, and pitch metrics.",
    },
    {
      title: "Sensor Fusion",
      desc: "Cross-modal integration between camera, radar, and LiDAR datasets.",
    },
  ];

  return (
    <main className="bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://i.pinimg.com/736x/90/32/1a/90321ae6a97ca6b9c3ac4d0de4a9f28c.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        {/* Subtle Tech Grid overlay */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Spatial Intelligence
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">2D & 3D</span>{" "}
              Labeling.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              High-precision ground truth datasets for computer vision,
              autonomous systems, and LiDAR-based spatial AI applications.
            </p>
            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
              >
                Initiate Project <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= 2D SERVICES (REFINED CARDS) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Ground Truth
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              2D Annotation Services
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {annotation2D.map((item, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-100 bg-white hover:border-indigo-100 hover:shadow-xl transition-all"
              >
                <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-6">
                  <item.icon size={24} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= 3D CAPABILITIES (CONTENT ALIGNED) ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left side content */}
            <motion.div {...fadeUp}>
              <div className="flex items-center gap-3 mb-4">
                <Cuboid className="text-indigo-600" size={28} />
                <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
                  3D Spatial Mastery
                </h2>
              </div>
              <p className="text-slate-600 mb-8 leading-relaxed font-light text-lg">
                Advanced labeling for depth-aware systems. We specialize in
                LiDAR and point-cloud annotation for mission-critical robotic
                environments.
              </p>

              <div className="space-y-6">
                {annotation3D.map((item, i) => (
                  <div key={i} className="flex gap-4">
                    <div className="shrink-0 w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-[10px]">
                      0{i + 1}
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-slate-900">
                        {item.title}
                      </h4>
                      <p className="text-xs text-slate-500 mt-1">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Right side image - matched height */}
            <div className="relative">
              <div className="absolute -inset-4 bg-indigo-100/50 rounded-3xl -z-10 blur-2xl opacity-50" />
              <div className="overflow-hidden rounded-2xl shadow-2xl border border-white h-[400px]">
                <img
                  src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80"
                  alt="3D Data Visualization"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= TECHNICAL CAPABILITIES (BENTO) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16 text-left">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Infrastructure Capabilities
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                icon: Zap,
                t: "High-Volume Execution",
                d: "Scalable pipelines handling millions of data points monthly.",
              },
              {
                icon: Database,
                t: "Multi-Format Output",
                d: "Support for JSON, XML, PCD, DICOM, and custom schemas.",
              },
              {
                icon: ShieldCheck,
                t: "Military-Grade Security",
                d: "SOC2 compliant data handling with secure tunnel ingestion.",
              },
              {
                icon: Globe2,
                t: "API-First Workflow",
                d: "Seamless hooks into your existing training pipelines.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="p-6 rounded-2xl bg-slate-900 text-white hover:bg-slate-800 transition-all text-left"
              >
                <item.icon className="text-indigo-400 mb-4" size={24} />
                <h4 className="font-bold text-sm mb-2">{item.t}</h4>
                <p className="text-[11px] text-slate-400 leading-relaxed font-light">
                  {item.d}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden border-t border-white/5 text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            Ready for Precision Scaling?
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Consult with our engineering team to define your labeling taxonomy
            and accelerate your model training cycles.
          </p>
          <div className="flex justify-center gap-4">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-8 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-50 transition-all shadow-xl"
            >
              Consult Data Expert
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}